import { USER_LEVELS, LEVEL_NAMES } from '../config/menuItems';

/**
 * Get the next level down in the hierarchy
 * @param {number} currentUserType - Current user type level (1-7)
 * @returns {number|null} Next level down, or null if at bottom (Client)
 */
export const getNextLevelUserType = (currentUserType) => {
  // Client (7) is the bottom level, no downline
  if (currentUserType === USER_LEVELS.CLIENT) {
    return null;
  }
  
  // Return the level below (higher number = lower in hierarchy)
  return currentUserType + 1;
};

/**
 * Check if a user can navigate to downline
 * @param {number} userType - User type level (1-7)
 * @returns {boolean} True if can navigate down, false if at bottom level
 */
export const canNavigateDown = (userType) => {
  return userType < USER_LEVELS.CLIENT;
};

/**
 * Get readable label for user type
 * @param {number} userType - User type level (1-7)
 * @returns {string} User type label
 */
export const formatUserTypeLabel = (userType) => {
  return LEVEL_NAMES[userType] || 'Unknown';
};

/**
 * Check if logged-in user can view a specific user type
 * @param {number} loggedInUserLevel - Logged-in user's level (1-7)
 * @param {number} targetUserLevel - Target user's level (1-7)
 * @returns {boolean} True if can view, false otherwise
 */
export const canViewUserLevel = (loggedInUserLevel, targetUserLevel) => {
  // Can only view users at lower levels
  return loggedInUserLevel > targetUserLevel;
};

/**
 * Get user type prefix for user ID
 * @param {number} userType - User type level (1-7)
 * @returns {string} User ID prefix (C, A, SA, M, SUB, AD, SAD)
 */
export const getUserTypePrefix = (userType) => {
  const prefixes = {
    [USER_LEVELS.CLIENT]: 'C',
    [USER_LEVELS.AGENT]: 'A',
    [USER_LEVELS.SUPERMASTER]: 'SA',
    [USER_LEVELS.MASTER]: 'M',
    [USER_LEVELS.MINIADMIN]: 'SUB',
    [USER_LEVELS.ADMIN]: 'AD',
    [USER_LEVELS.SUPERADMIN]: 'SAD'
  };
  
  return prefixes[userType] || '';
};

/**
 * Build breadcrumb trail for downline navigation
 * @param {Array} navigationPath - Array of {name, userId, userType} objects
 * @returns {Array} Breadcrumb items
 */
export const buildBreadcrumbs = (navigationPath) => {
  return navigationPath.map((item, index) => ({
    title: item.name,
    userId: item.userId,
    userType: item.userType,
    isLast: index === navigationPath.length - 1
  }));
};